import React, { useEffect, useState } from "react";
import List from "../Components/Coupon History/List";
import View from "../Components/Coupon History/View";
import TransactionView from "../Components/Artisan/TransactionDetail";
import Layout from "../Layout";
import { useLocation } from "react-router-dom";

function CouponHistory() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();

  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }
  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Coupon History</h1>
          </div>

          {comp === "list" ? (
            <List comp={comp} onChange={handleChange} rowData={rowData} />
          ) : comp === "transaction" ? (
            <TransactionView
              comp={comp}
              onChange={handleChange}
              rowData={rowData}
            />
          ) : (
            <View comp={comp} rowData={rowData} onChange={handleChange} />
          )}
        </section>
      </div>
    </Layout>
  );
}

export default CouponHistory;
